import { useState } from 'react';
import { ButtonRow, Popup, SelectMenu, Textarea, Textbox } from 'components/generic';
import './styles.scss';
import { cloneDeep } from 'lodash';
import { getValuesById } from 'utils';

export default function CreateFact(props) {
	const { dataType, handleCreatePopup, popupState, handlePopupToggler } = props;

	const [factData, setFactData] = useState({ fa_formula_type: 'DIRECT' });

	const handleButtonClick = e => {
		e === 'Yes' && handleCreatePopup(factData);
		handleClose();
	};

	const dataHandler = (e, key) => {
		setFactData(ps => {
			const state = cloneDeep(ps);
			state[key] = key === 'fa_allowed_data_type' ? [e] : e;
			return state;
		});
	};

	const handleClose = () => {
		setFactData({ fa_formula_type: 'DIRECT' });
		handlePopupToggler();
	};

	return (
		<>
			<Popup popupState={popupState} onClose={handleClose}>
				<div className='fact-detail__container'>
					<h2>Create Fact</h2>
					<div className='fact-detail'>
						<div className='row'>
							<div className='col-6'>
								<Textbox label='Fact Name' infoContent="Enter Fact Name" mandatory placeholder='Eg: customer name' value={factData?.fa_name} onChange={e => dataHandler(e?.target?.value, 'fa_name')} />
							</div>
							<div className='col-6'>
								<SelectMenu label='Data Type' infoContent="Select Data Type" placeholder='Eg: String' menuOptions={dataType} mandatory value={getValuesById(dataType, factData?.fa_allowed_data_type?.at())} onChange={e => dataHandler(e, 'fa_allowed_data_type')} />
							</div>
						</div>
						<div className='row'>
							<div className='col-12'>
								<Textbox label='Example' infoContent="Select Data Type" mandatory placeholder='Eg. Dilip' value={factData?.fa_example} onChange={e => dataHandler(e?.target?.value, 'fa_example')} />
							</div>
						</div>
					</div>
					<Textarea label='Description' infoContent="Enter the description" placeholder='Type here' name='fa_description' value={factData?.fa_description} onChange={e => dataHandler(e?.target?.value, 'fa_description')} />
					<ButtonRow right label='No' label1='Yes' handleButtonClick={handleButtonClick} />
				</div>
			</Popup>
		</>
	);
}
